/**
 * TicketDetailPage - Página de detalhes do ticket (deep-link `/helpdesk/tickets/:id`).
 *
 * O corpo vive em `TicketDetailContent` (reutilizado pelo `TicketDetailDrawer`
 * aberto ao clicar num card do board — #150). Aqui só resolvemos o `id` da rota.
 */

import React from 'react';
import { useParams } from 'react-router-dom';

import { TicketDetailContent } from '../components/TicketDetailContent';

export const TicketDetailPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  return <TicketDetailContent ticketId={id || ''} />;
};
